import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import styles from "./styles.module.css";
import Modal from "react-modal";
import image from "../../assets/images/imgModalFood.png";
import { Input } from "../inputs/inputs";
import { useFoodConfig } from "../../hooks/useFood";
import { CiCamera } from "react-icons/ci";
import { QrReader } from "../QrCodeReader/QrCodeReader";
import { Slide, ToastContainer, toast } from "react-toastify";
import ReactLoading from "react-loading";
import { AlertComponentModal } from "../AlertComponentModal/alertComponentModal";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useToast } from "../../hooks/useToast";

type ModalComanda = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  enter: (value?: any) => void;
};

type Step = 1 | 2 | 3 | 4 | 5;

const ModalComandaFood: FC<ModalComanda> = ({ isOpen, setIsOpen, enter }) => {
  const [step, setStep] = useState<Step>(1);
  const { pluginspace } = usePluginspace();
  const [geoLocationLoading, setGeoLocationLoading] = useState<boolean>(false);
  const [responsability, setResponsability] = useState<boolean>(false);
  const [responsabilityAlert, setResponsabilityAlert] =
    useState<boolean>(false);
  const [phoneAlert, setPhoneAlert] = useState<boolean>(false);
  const [nameAlert, setNameAlert] = useState<boolean>(false);
  const [openCamera, setOpenCamera] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const toastComponent = useToast();

  const useFood = useFoodConfig();

  function habilitarGeolocalizacao() {
    try {
      if ("geolocation" in navigator) {
        setIsLoading(true);
        setGeoLocationLoading(true);
        const wasKicked = localStorage.getItem("was_kicked");
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const response = success(position);

            if (
              useFood.securityConfig?.locationRadius &&
              response * 1000 <= useFood.securityConfig?.locationRadius &&
              !wasKicked
            ) {
              const goFowardResponse = await goFoward();
              setGeoLocationLoading(false);
              if (goFowardResponse && goFowardResponse.success) {
                localStorage.setItem("first_access", "true");
                enter();
              } else {
                setStep(2);
              }
            } else {
              let message = `Você está fora da nossa área de cobertura. Quando estiver de volta, lembre-se de tocar em 'Ler QR code' para garantir que esteja ${
                useFood.isTable ? "em uma mesa!" : "com sua comanda em mãos!"
              }`;

              if (wasKicked) {
                message =
                  "O acesso a essa mesa foi encerrado. Para continuar fazendo pedidos, leia o QR code novamente clicando no botão abaixo. Ou usando um leitor de QR code.";
              }

              setMessage(message);
              setStep(4);
              setShowAlert(true);
            }
            setIsLoading(false);
          },
          (error) => {
            setShowAlert(true);
            setStep(5);
            setMessage(
              "Você bloqueou a permissão de localização. Para continuar, vá até as configurações do dispositivo e toque em “redefinir permissões”. Em seguida, recarregue essa página"
            );
            setIsLoading(false);
          }
        );
      } else {
        setShowAlert(true);
        setStep(5);
        setMessage("Geolocalização não é suportada pelo seu navegador.");
        setIsLoading(false);
      }
    } catch (error) {
      setShowAlert(true);
      setStep(5);
      setMessage("Geolocalização não é suportada pelo seu navegador.");
      setIsLoading(false);
    }
  }

  function success(position: any) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    // Aqui você chamaria a função para calcular a distância
    if (pluginspace) {
      const distance = useFood.calculateDistance(
        latitude,
        longitude,
        parseFloat(pluginspace.address.lat),
        parseFloat(pluginspace.address.lng)
      );
      return distance;
    }

    return 0;
  }

  async function goToCardapio() {
    try {
      if (!useFood.customerName || !responsability) {
        !useFood.customerName && setNameAlert(true);

        if (!useFood.customerName) {
          toastComponent.openToast("warning", "Informe um nome válido");
          return;
        }

        /*
        !useFood.customerPhone && setPhoneAlert(true)
        if (!useFood.customerPhone) {
          toastComponent.openToast('warning', 'Informe um telefone válido')
          return
        }*/

        !responsability && setResponsabilityAlert(true);

        if (!responsability) {
          toastComponent.openToast("warning", "É necessario aceitar os termos");
          return;
        }
      } else {
        setIsLoading(true);

        const hasDevideId = await useFood.hasDeviceId();
        let deviceId = "";
        if (!hasDevideId || !hasDevideId.success) {
          deviceId = await useFood.createUniqueDevice();
        } else if (hasDevideId && hasDevideId.success) {
          deviceId = hasDevideId.deviceId;
          // fazer validacao para saber se o device esta vinculado a mesa/comanda ativa
          const response = await useFood.verifyDevice(deviceId);

          if (response && response.success) {
            deviceId = await useFood.createUniqueDevice();
          }
        }

        //const deviceId = await useFood.loadUniqueDevice()
        const response = await useFood.vinculateDevice(deviceId);
        setIsLoading(false);

        if (!response || !response.success) {
          if (response.msg === "Device já vinculado a mesa/comanda") {
            localStorage.setItem("first_access", "true");
            enter();
          } else if (response.msg === "Comanda já vinculada") {
            setMessage(
              "Identificamos que a comanda já está em uso. Verifique se esta é a sua comanda ou entre em contato com o garçom."
            );
            setStep(4);
            setShowAlert(true);
          } else if (
            response.msg ===
            "Vinculo de usuarios na mesa atingido, favor chamar garçom"
          ) {
            setMessage(
              "Notamos que o número máximo de aparelhos foi atingido. Entre em contato com o garçom."
            );
            setStep(3);
            setShowAlert(true);
          } else if (response.msg === "Device vinculado a outra mesa/comanda") {
            setMessage(
              "Identificamos que esse aparelho está vinculado a outra comanda/mesa.  Verifique se esta é a sua comanda/mesa ou entre em contato com o garçom."
            );
            setStep(4);
            setShowAlert(true);
          } else {
            toastComponent.openToast(
              "error",
              "Um erro inesperado aconteceu, tente novamente."
            );
            return;
          }
        } else {
          localStorage.setItem("first_access", "true");
          enter();
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  function readQrcode(value: string) {
    try {
      if (value && value.includes("/table/")) {
        const link = value.split("/table/")[1];

        if (link) {
          const tableNumber = link.split("/")[0];

          if (tableNumber) {
            useFood.setTableNumber(parseInt(window.atob(tableNumber)));
            setOpenCamera(false);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function readNewQrcode(value: string) {
    localStorage.removeItem("should_show_ler_qrcodeButton");
    localStorage.removeItem("first_access");
    localStorage.removeItem("reload_app_food");
    localStorage.removeItem("removed_by_admin");
    localStorage.removeItem("removed_by_admin_table");
    window.open(value, "_self");
  }

  function isValid() {
    try {
      const removed_by_admin = localStorage.getItem("removed_by_admin");
      if (removed_by_admin) {
        setStep(4);
        const isTable = JSON.parse(
          localStorage.getItem("removed_by_admin_table") ?? "true"
        );
        if (isTable) {
          setMessage(
            "O acesso a essa mesa foi encerrado. Para continuar fazendo pedidos, leia o QR code novamente clicando no botão abaixo."
          );
        } else {
          setMessage(
            "O acesso a essa comanda foi encerrado. Para continuar fazendo pedidos, leia o QR code novamente clicando no botão abaixo"
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  // funcao utilizada para validar se o cliente ja
  // esta vindulado a uma mesa/comanda e nao seguir os passos
  // de cadastro...
  async function goFoward() {
    try {
      const hasDevideId = await useFood.hasDeviceId();
      let deviceId = "";

      //Nao existe id unico para esse device. Deve seguir a rota de cadastro
      if (!hasDevideId || !hasDevideId.success) {
        return {
          success: false,
          data: {},
          msg: "Primeiro acesso",
        };
      }
      deviceId = hasDevideId.deviceId;

      // Valida de o device esta vinculado a mesa/comanda ativa.
      // Se response for false -> está vinculado a mesa/comanda ativa
      // se a response for true -> nao esta vinculado a mesa/comanda ativa
      const response = await useFood.verifyDevice(deviceId);

      if (!response || response.success) {
        return {
          success: false,
          data: {},
          msg: "Não está vinculado, logo deve realizar o processo de cadastro.",
        };
      }
      const responseVinculated = await useFood.vinculateDevice(deviceId);

      if (!responseVinculated || !responseVinculated.success) {
        if (responseVinculated.msg === "Device já vinculado a mesa/comanda") {
          useFood.setCustomerName(responseVinculated.data.customerName);
          return {
            data: {},
            msg: "Device já vinculado a mesa/comanda",
            success: true,
          };
        }
      }
      return {
        data: {},
        msg: "Device já vinculado a mesa/comanda",
        success: false,
      };
    } catch (error) {
      return {
        data: {},
        msg: "Device já vinculado a mesa/comanda",
        success: false,
      };
    }
  }

  async function vinculaByGarcom() {
    try {
      setIsLoading(true);
      const deviceId = await useFood.loadUniqueDevice();
      const response = await useFood.vinculateDeviceByWaiter(
        password,
        deviceId
      );

      setIsLoading(false);
      setPassword("");
      if (!response || !response.success) {
        if (response.msg === "Senha invalida") {
          setShowAlert(true);
          setMessage("Senha invalida");
          return;
        }

        if (response.msg === "Device já vinculado a mesa/comanda") {
          enter();
          return;
        }
      }
      localStorage.setItem("first_access", "true");
      enter();
      return;
    } catch (error) {}
  }

  useEffect(() => {
    isValid();
  }, []);

  useEffect(() => {
    if (!useFood.shouldMakeRequest) {
      setTimeout(() => setIsLoading(false), 2000);
    }
  }, [useFood.shouldMakeRequest]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className={styles.modal}
      contentLabel=""
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className={styles.modal}>
        {step === 1 && (
          <div className={styles.body}>
            <img src={image} alt="" className={styles.image} />
            <div className={styles.content}>
              <span>
                Para acessar o cardápio, vamos precisar da sua localização. É só
                clicar no botão abaixo para continuar.
              </span>

              <button
                onClick={() => habilitarGeolocalizacao()}
                className={`${geoLocationLoading && styles.is_loading}`}
              >
                {" "}
                Permitir Localização{" "}
                {geoLocationLoading && (
                  <ReactLoading
                    type={"spin"}
                    color={"#FFFFFF"}
                    height={"25px"}
                    width={"25px"}
                  />
                )}
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className={styles.body}>
            <div className={styles.content}>
              <Input
                inputAttr={{
                  type: "default",
                }}
                label="Nome"
                name="Nome"
                value={useFood.customerName ? useFood.customerName : ""}
                change={(value: string) => {
                  useFood.setCustomerName(value);
                  setNameAlert(false);
                }}
                warning={nameAlert}
              />
              {!useFood.isTable && useFood.isCard && (
                <div className={styles.input_container}>
                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    <Input
                      inputAttr={{
                        type: "default",
                      }}
                      textCenter
                      label="Número da Mesa (Opcional)"
                      name="Número da Mesa"
                      value={useFood.tableNumber ? useFood.tableNumber : ""}
                      change={(value: number) => {
                        if (
                          (value && Number(value) > 0) ||
                          value.toString() === ""
                        ) {
                          useFood.setTableNumber(value);
                        }
                      }}
                    />
                  </div>

                  <div
                    className={styles.button_camera}
                    onClick={() => {
                      setOpenCamera(true);
                    }}
                  >
                    <CiCamera />
                  </div>
                </div>
              )}

              <Input
                inputAttr={{
                  type: "checkbox",
                }}
                textCenter
                label="Ao prosseguir você confirma que todo pedido realizado por este aparelho de celular será de sua responsabilidade"
                name="responsability"
                value={responsability}
                checked={responsability}
                change={(value: boolean) => {
                  setResponsability(value);
                  value && setResponsabilityAlert(false);
                }}
                warning={responsabilityAlert}
              />
              <button
                onClick={() => {
                  !isLoading && goToCardapio();
                }}
                className={`${isLoading && styles.is_loading}`}
              >
                {" "}
                Acessar Cardápio{" "}
                {isLoading && (
                  <ReactLoading
                    type={"spin"}
                    color={"#FFFFFF"}
                    height={"25px"}
                    width={"25px"}
                  />
                )}
              </button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className={styles.body}>
            <div className={styles.content}>
              {showAlert ? (
                <AlertComponentModal msg={message} type={"error"} />
              ) : (
                <Input
                  inputAttr={{
                    type: "default",
                  }}
                  label="Senha"
                  name="Senha"
                  value={password}
                  change={(value: string) => {
                    setPassword(value);
                  }}
                />
              )}

              <button
                onClick={() => {
                  showAlert ? setShowAlert(false) : vinculaByGarcom();
                }}
                className={`${isLoading && styles.is_loading}`}
              >
                {" "}
                Liberar Acesso{" "}
                {isLoading && (
                  <ReactLoading
                    type={"spin"}
                    color={"#FFFFFF"}
                    height={"25px"}
                    width={"25px"}
                  />
                )}
              </button>
            </div>
          </div>
        )}

        {step === 4 && (
          <div className={styles.body}>
            <div className={styles.content}>
              <AlertComponentModal msg={message} type={"error"} />

              <button
                onClick={() => {
                  setOpenCamera(true);
                }}
                className={``}
              >
                {" "}
                Ler QRcode
              </button>
            </div>
          </div>
        )}
        {step === 5 && (
          <div className={styles.body}>
            <div className={styles.content}>
              <AlertComponentModal msg={message} type={"error"} />
            </div>
          </div>
        )}
      </div>

      {openCamera && (
        <QrReader setScannedResult={step === 4 ? readNewQrcode : readQrcode} />
      )}
    </Modal>
  );
};

export { ModalComandaFood };
